/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { PropsWithChildren } from 'react'

function Page (props: PropsWithChildren) {
  const { children } = props
  return (
    <>
      {children}
    </>
  )
}

export default Page
